export const areaFilters = [
	{
		label: '<= 30',
		filterValue: {
			'area@gte': undefined,
			'area@lte': 30
		}
	},
	{
		label: '<= 40',
		filterValue: {
			'area@gte': undefined,
			'area@lte': 40
		}
	},
	{
		label: '<= 50',
		filterValue: {
			'area@gte': undefined,
			'area@lte': 50
		}
	},
	{
		label: '<= 60',
		filterValue: {
			'area@gte': undefined,
			'area@lte': 60
		}
	},
	{
		label: '<= 70',
		filterValue: {
			'area@gte': undefined,
			'area@lte': 70
		}
	},
	{
		label: '<= 80',
		filterValue: {
			'area@gte': undefined,
			'area@lte': 80
		}
	},
	{
		label: '<= 90',
		filterValue: {
			'area@gte': undefined,
			'area@lte': 90
		}
	},
	{
		label: '<= 100',
		filterValue: {
			'area@gte': undefined,
			'area@lte': 100
		}
	},
	{
		label: '100 - 150',
		filterValue: {
			'area@gte': 100,
			'area@lte': 150
		}
	},
	{
		label: '150 - 200',
		filterValue: {
			'area@gte': 150,
			'area@lte': 200
		}
	},
	{
		label: '> 200',
		filterValue: {
			'area@gte': 200,
			'area@lte': undefined
		}
	}
];
